// Trim a page <title> to fit Google's SERP limits: ~561px pixel budget AND ~60 characters
// (Screaming Frog's default title-length filter). Google truncates by pixels, but the 60-char
// rule is the common editorial guideline — we honour whichever is more restrictive.
const BRAND = " | Ma Petite Ferme";

function titlePx(s) {
  if (typeof document === "undefined") return (s || "").length * 9; // rough SSR fallback
  const ctx = (titlePx._c = titlePx._c || document.createElement("canvas").getContext("2d"));
  ctx.font = "700 20px Arial"; // approximates Google's SERP title font
  return ctx.measureText(s || "").width;
}

const fits = (s, px, chars) => s.length <= chars && titlePx(s) <= px;

function truncBoth(t, px, chars) {
  const words = t.split(" ");
  let out = "";
  for (const w of words) {
    const trial = out ? `${out} ${w}` : w;
    // reserve 1 char / a few px for the ellipsis
    if (trial.length + 1 > chars || titlePx(`${trial}…`) > px) break;
    out = trial;
  }
  if (!out) {
    out = t.slice(0, chars - 1);
    while (out && titlePx(`${out}…`) > px) out = out.slice(0, -1);
  }
  return `${out.replace(/[\s,;:.\-–—|]+$/, "")}…`;
}

// px < 561 and chars = 60 leave a small safety margin.
export function clampTitle(s, { px = 555, chars = 60 } = {}) {
  if (typeof s !== "string") return s;
  const t = s.trim();
  if (fits(t, px, chars)) return t;
  if (t.endsWith(BRAND)) {
    const base = t.slice(0, -BRAND.length).trim();
    if (fits(base, px, chars)) return base; // drop brand suffix if that's enough
    return truncBoth(base, px, chars);
  }
  return truncBoth(t, px, chars);
}
